import { Button, Icon } from '@material-tailwind/react';
import { useHistory } from 'react-router-dom';

export default function BackButton(props) {
    const history = useHistory();

    return (
        <Button
            color="red"
            rounded
            className="pl-0 hover:ml-4 ml-6 text-red hover:bg-transparent"
            buttonType="link"
            size="lg"
            ripple="dark"
            onClick={() => history.goBack()}
            style={{paddingLeft: 0}}
            {...props}
        >
            <Icon name="arrow_back" color="red" size="sm" />
            Back           
        </Button>
    )
}


